<div class="content-info">
  <div class="content-title d-flex flex-column flex-md-row align-items-md-center justify-content-between">
    <h3 class="title mb-3 mb-md-0">Service Master</h3>
    <div class="title-actions d-flex flex-wrap align-items-center gap-2">
      <!-- Search Service input -->
      <div class="form-group mb-0">
        <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()" placeholder="Search Service Name..."
          class="form-control" style="min-width: 200px;" />
      </div>

      <!-- Create Service button -->
      <button class="btn btnprimary text-nowrap" [routerLink]="['/services/create']">
        <i class="bi bi-plus-lg"></i> Create Service
      </button>
    </div>
  </div>

  <div class="common-table">
    <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
      <table class="table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Department</th>
            <th>Price</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @if (serviceLoading) {
          <tr>
            <td colspan="5" class="text-center">Loading services...</td>
          </tr>
          } @else if (!serviceList.length) {
          <tr>
            <td colspan="5" class="text-center">No services found.</td>
          </tr>
          } @else { @for (service of serviceList; track service.id) {
          <tr>
            <td>
              <a [routerLink]="['/services/edit', service.id]" [queryParams]="{ view: true }">{{ service.name }}</a>
            </td>
            <td>{{ service.department?.name || "-" }}</td>
            <td>₹{{ service.price | number : "1.2-2" }}</td>
            <td>
              <span class="badge" [ngClass]="{
                  'bg-success': service.isActive,
                  'bg-danger': !service.isActive
                }">
                {{ service.isActive ? "ACTIVE" : "INACTIVE" }}
              </span>
            </td>
            <td>
              <div class="td-actions-btn">
                <button class="btn btn-edit" [routerLink]="['/services/edit', service.id]">
                  <i class="bi bi-pencil-square"></i>
                </button>
              </div>
            </td>
          </tr>
          } }
        </tbody>
      </table>
    </div>

    <div class="table-pagination">
      <div class="pagination-count">
        <select [(ngModel)]="pageSize" (change)="pageSizeChange()">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="30">30</option>
          <option value="40">40</option>
        </select>
        <span>entries per page</span>
      </div>

      <ul class="pagination">
        <li class="page-item" [class.disabled]="currentPage === 1">
          <a class="page-link" (click)="goToPage(currentPage - 1)">&laquo;</a>
        </li>

        <li class="page-item" *ngFor="let p of pages" [class.active]="p === currentPage">
          <a class="page-link" (click)="goToPage(p)">{{ p }}</a>
        </li>

        <li class="page-item" [class.disabled]="currentPage === totalPages">
          <a class="page-link" (click)="goToPage(currentPage + 1)">>></a>
        </li>
      </ul>
    </div>
  </div>
</div>